module.exports = __webpack_public_path__ + "img/promocode.07935f30.gif";